import { NgModule } from '@angular/core';
import { Radio } from './radio';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [Radio],
    exports: [Radio],
    imports: [FormsModule],
})
export class RadioModule {
}